import { useMemo } from "react";
import { Product } from "@/services/productService";

const useProductVeryFirstSize = (product: Product) => {
  return useMemo(() => {
    const productSizes = product.sizes || [];
    return productSizes?.[0]?.variants[0];
  }, [product]);
};

export default useProductVeryFirstSize;
